import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IListenToResourcePropertiesSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenToResourcePropertiesSubscription = {
  resourceProperty?: {
    id?: any | null
    item?: { resourceTypeId: string } | null
  } | null
}

export type IListenToResourceTemplatesSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenToResourceTemplatesSubscription = {
  resourceTemplate?: {
    id?: any | null
    item?: { resourceTypeId: string } | null
  } | null
}

export type IGetResourcePropertiesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  resourceTypeId: Types.Scalars['String']['input']
  includeArchived?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type IGetResourcePropertiesQuery = {
  resourceProperties?: Array<{
    id?: any | null
    resourceTypeId: string
    isExternal: boolean
    isArchived: boolean
    createdBy?: any | null
    name: string
    displayName?: string | null
    propertyType: Types.PropertyType
    position: number
    updatedAt?: any | null
    configuration: {
      multiline?: boolean | null
      format?: string | null
      allowCustomOptions?: boolean | null
      includeNoneOption?: boolean | null
      computationKind?: string | null
      fromField?: string | null
      toField?: string | null
      unit?: string | null
      maxFiles?: number | null
      acceptedFileTypes?: Array<string | null> | null
      maxFileSizeMb?: number | null
      options?: Array<{
        value: string
        label: string
        deleted: boolean
        parentValue?: string | null
      }> | null
      resourceLink?: { targetResourceType: string; exclusive: boolean } | null
      importExport?: {
        entityType?: string | null
        exportField?: string | null
        importField?: string | null
      } | null
    }
  }> | null
}

export type IGetResourceTemplatesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  resourceTypeId: Types.Scalars['String']['input']
}>

export type IGetResourceTemplatesQuery = {
  resourceTemplates?: Array<{
    id?: any | null
    resourceTypeId: string
    name: string
    description?: string | null
    codePrefix?: string | null
    createdBy?: string | null
    updatedAt?: any | null
    updatedBy?: string | null
    appliedObjectsCount: number
    cardConfiguration?: {
      subtitleProperty?: string | null
      displayProperties: Array<string>
    } | null
    properties: Array<{
      propertyId: any
      propertyName: string
      orderIndex: number
      isRequired: boolean
      isHidden: boolean
      defaultValue?: string | null
      property?: {
        id?: any | null
        name: string
        displayName?: string | null
        propertyType: Types.PropertyType
        configuration: {
          multiline?: boolean | null
          format?: string | null
          allowCustomOptions?: boolean | null
          includeNoneOption?: boolean | null
          maxFiles?: number | null
          acceptedFileTypes?: Array<string | null> | null
          maxFileSizeMb?: number | null
          options?: Array<{
            value: string
            label: string
            deleted: boolean
            parentValue?: string | null
          }> | null
          resourceLink?: {
            targetResourceType: string
            exclusive: boolean
          } | null
          importExport?: {
            entityType?: string | null
            exportField?: string | null
            importField?: string | null
          } | null
        }
      } | null
    }>
  }> | null
}

export type IUpdateResourcePropertyMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  id: Types.Scalars['ObjectId']['input']
  input: Types.IUpdateResourcePropertyInput
}>

export type IUpdateResourcePropertyMutation = {
  updateResourceProperty?: {
    id?: any | null
    name: string
    displayName?: string | null
    position: number
    configuration: {
      multiline?: boolean | null
      format?: string | null
      allowCustomOptions?: boolean | null
      includeNoneOption?: boolean | null
      maxFiles?: number | null
      acceptedFileTypes?: Array<string | null> | null
      maxFileSizeMb?: number | null
      options?: Array<{
        value: string
        label: string
        deleted: boolean
        parentValue?: string | null
      }> | null
      resourceLink?: { targetResourceType: string; exclusive: boolean } | null
      importExport?: {
        entityType?: string | null
        exportField?: string | null
        importField?: string | null
      } | null
    }
  } | null
}

export type ICreateResourcePropertyMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  input: Types.ICreateResourcePropertyInput
}>

export type ICreateResourcePropertyMutation = {
  createResourceProperty?: {
    id?: any | null
    resourceTypeId: string
    isExternal: boolean
    name: string
    displayName?: string | null
    propertyType: Types.PropertyType
    position: number
    updatedAt?: any | null
    configuration: {
      multiline?: boolean | null
      format?: string | null
      allowCustomOptions?: boolean | null
      includeNoneOption?: boolean | null
      computationKind?: string | null
      fromField?: string | null
      toField?: string | null
      unit?: string | null
      maxFiles?: number | null
      acceptedFileTypes?: Array<string | null> | null
      maxFileSizeMb?: number | null
      options?: Array<{
        value: string
        label: string
        deleted: boolean
        parentValue?: string | null
      }> | null
      resourceLink?: { targetResourceType: string; exclusive: boolean } | null
      importExport?: {
        entityType?: string | null
        exportField?: string | null
        importField?: string | null
      } | null
    }
  } | null
}

export type IDeleteResourcePropertyMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  id: Types.Scalars['ObjectId']['input']
}>

export type IDeleteResourcePropertyMutation = {
  deleteResourceProperty?: boolean | null
}

export type ICreateResourceTemplateMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  input: Types.ICreateResourceTemplateInput
}>

export type ICreateResourceTemplateMutation = {
  createResourceTemplate?: {
    id?: any | null
    resourceTypeId: string
    name: string
  } | null
}

export type IUpdateResourceTemplateMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  id: Types.Scalars['ObjectId']['input']
  input: Types.IUpdateResourceTemplateInput
}>

export type IUpdateResourceTemplateMutation = {
  updateResourceTemplate?: {
    id?: any | null
    properties: Array<{
      propertyId: any
      propertyName: string
      orderIndex: number
      isRequired: boolean
      isHidden: boolean
      defaultValue?: string | null
    }>
  } | null
}

export type IDeleteResourceTemplateMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  id: Types.Scalars['ObjectId']['input']
}>

export type IDeleteResourceTemplateMutation = {
  deleteResourceTemplate?: boolean | null
}

export type IDeleteManyResourceTemplatesMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  ids:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
}>

export type IDeleteManyResourceTemplatesMutation = {
  deleteManyResourceTemplates?: boolean | null
}

export type IUpdateResourceTemplatePropertySettingsMutationVariables =
  Types.Exact<{
    projectId: Types.Scalars['ObjectId']['input']
    templateId: Types.Scalars['ObjectId']['input']
    propertyId: Types.Scalars['ObjectId']['input']
    input: Types.ITemplatePropertySettingsInput
  }>

export type IUpdateResourceTemplatePropertySettingsMutation = {
  updateTemplatePropertySettings?: {
    id?: any | null
    properties: Array<{
      propertyId: any
      propertyName: string
      orderIndex: number
      isRequired: boolean
      isHidden: boolean
      defaultValue?: string | null
    }>
  } | null
}

export type IParseResourceImportFileQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  storagePath: Types.Scalars['String']['input']
  resourceTypeId: Types.Scalars['String']['input']
}>

export type IParseResourceImportFileQuery = {
  parseResourceImportFile?: {
    headers: Array<string>
    rowCount: number
    suggestedMappings: Array<{
      columnIndex: number
      columnHeader: string
      propertyId?: string | null
      propertyName?: string | null
      field?: string | null
    }>
  } | null
}

export type IExecuteResourceImportMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  storagePath: Types.Scalars['String']['input']
  resourceTypeId: Types.Scalars['String']['input']
  templateId: Types.Scalars['String']['input']
  mappings: Array<Types.IColumnMappingInput> | Types.IColumnMappingInput
}>

export type IExecuteResourceImportMutation = {
  executeResourceImport?: {
    created: number
    updated: number
    failed: number
    errors: Array<{
      row: number
      propertyName?: string | null
      value?: string | null
      message: string
    }>
  } | null
}

export type IExportResourceRecordsMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  input: Types.IResourceExportRecordsInput
}>

export type IExportResourceRecordsMutation = {
  exportResourceRecords?: {
    data?: string | null
    filename?: string | null
    mimeType?: string | null
  } | null
}

export type IBulkEditResourcePropertiesMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  input: Types.IBulkEditResourcePropertiesInput
}>

export type IBulkEditResourcePropertiesMutation = {
  bulkEditResourceProperties?: Array<any> | null
}

export type IGetResourcePropertyUsageCountQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  id: Types.Scalars['ObjectId']['input']
}>

export type IGetResourcePropertyUsageCountQuery = {
  resourcePropertyUsageCount?: number | null
}

export type IArchiveResourcePropertyMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  id: Types.Scalars['ObjectId']['input']
}>

export type IArchiveResourcePropertyMutation = {
  archiveResourceProperty?: boolean | null
}

export type IUnarchiveResourcePropertyMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  id: Types.Scalars['ObjectId']['input']
}>

export type IUnarchiveResourcePropertyMutation = {
  unarchiveResourceProperty?: boolean | null
}

export type IHierarchyPropertyOptionUsageQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  propertyId: Types.Scalars['ObjectId']['input']
}>

export type IHierarchyPropertyOptionUsageQuery = {
  hierarchyPropertyOptionUsage?: Array<string> | null
}

export const ListenToResourcePropertiesDocument = gql`
  subscription ListenToResourceProperties($projectId: ObjectId!) {
    resourceProperty(projectId: $projectId) {
      id
      item {
        resourceTypeId
      }
    }
  }
`

/**
 * __useListenToResourcePropertiesSubscription__
 *
 * To run a query within a React component, call `useListenToResourcePropertiesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToResourcePropertiesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToResourcePropertiesSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenToResourcePropertiesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToResourcePropertiesSubscription,
    IListenToResourcePropertiesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToResourcePropertiesSubscription,
    IListenToResourcePropertiesSubscriptionVariables
  >(ListenToResourcePropertiesDocument, options)
}
export type ListenToResourcePropertiesSubscriptionHookResult = ReturnType<
  typeof useListenToResourcePropertiesSubscription
>
export type ListenToResourcePropertiesSubscriptionResult =
  Apollo.SubscriptionResult<IListenToResourcePropertiesSubscription>
export const ListenToResourceTemplatesDocument = gql`
  subscription ListenToResourceTemplates($projectId: ObjectId!) {
    resourceTemplate(projectId: $projectId) {
      id
      item {
        resourceTypeId
      }
    }
  }
`

/**
 * __useListenToResourceTemplatesSubscription__
 *
 * To run a query within a React component, call `useListenToResourceTemplatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToResourceTemplatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToResourceTemplatesSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenToResourceTemplatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToResourceTemplatesSubscription,
    IListenToResourceTemplatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToResourceTemplatesSubscription,
    IListenToResourceTemplatesSubscriptionVariables
  >(ListenToResourceTemplatesDocument, options)
}
export type ListenToResourceTemplatesSubscriptionHookResult = ReturnType<
  typeof useListenToResourceTemplatesSubscription
>
export type ListenToResourceTemplatesSubscriptionResult =
  Apollo.SubscriptionResult<IListenToResourceTemplatesSubscription>
export const GetResourcePropertiesDocument = gql`
  query GetResourceProperties(
    $projectId: ObjectId!
    $resourceTypeId: String!
    $includeArchived: Boolean
  ) {
    resourceProperties(
      projectId: $projectId
      resourceTypeId: $resourceTypeId
      includeArchived: $includeArchived
    ) {
      id
      resourceTypeId
      isExternal
      isArchived
      createdBy
      name
      displayName
      propertyType
      position
      updatedAt
      configuration {
        multiline
        format
        options {
          value
          label
          deleted
          parentValue
        }
        allowCustomOptions
        includeNoneOption
        computationKind
        fromField
        toField
        unit
        maxFiles
        acceptedFileTypes
        maxFileSizeMb
        resourceLink {
          targetResourceType
          exclusive
        }
        importExport {
          entityType
          exportField
          importField
        }
      }
    }
  }
`

/**
 * __useGetResourcePropertiesQuery__
 *
 * To run a query within a React component, call `useGetResourcePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcePropertiesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      resourceTypeId: // value for 'resourceTypeId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetResourcePropertiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetResourcePropertiesQuery,
    IGetResourcePropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetResourcePropertiesQuery,
    IGetResourcePropertiesQueryVariables
  >(GetResourcePropertiesDocument, options)
}
export function useGetResourcePropertiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetResourcePropertiesQuery,
    IGetResourcePropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetResourcePropertiesQuery,
    IGetResourcePropertiesQueryVariables
  >(GetResourcePropertiesDocument, options)
}
export type GetResourcePropertiesQueryHookResult = ReturnType<
  typeof useGetResourcePropertiesQuery
>
export type GetResourcePropertiesLazyQueryHookResult = ReturnType<
  typeof useGetResourcePropertiesLazyQuery
>
export type GetResourcePropertiesQueryResult = Apollo.QueryResult<
  IGetResourcePropertiesQuery,
  IGetResourcePropertiesQueryVariables
>
export const GetResourceTemplatesDocument = gql`
  query GetResourceTemplates($projectId: ObjectId!, $resourceTypeId: String!) {
    resourceTemplates(projectId: $projectId, resourceTypeId: $resourceTypeId) {
      id
      resourceTypeId
      name
      description
      codePrefix
      createdBy
      updatedAt
      updatedBy
      appliedObjectsCount
      cardConfiguration {
        subtitleProperty
        displayProperties
      }
      properties {
        propertyId
        propertyName
        orderIndex
        isRequired
        isHidden
        defaultValue
        property {
          id
          name
          displayName
          propertyType
          configuration {
            multiline
            format
            options {
              value
              label
              deleted
              parentValue
            }
            allowCustomOptions
            includeNoneOption
            maxFiles
            acceptedFileTypes
            maxFileSizeMb
            resourceLink {
              targetResourceType
              exclusive
            }
            importExport {
              entityType
              exportField
              importField
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetResourceTemplatesQuery__
 *
 * To run a query within a React component, call `useGetResourceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceTemplatesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      resourceTypeId: // value for 'resourceTypeId'
 *   },
 * });
 */
export function useGetResourceTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetResourceTemplatesQuery,
    IGetResourceTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetResourceTemplatesQuery,
    IGetResourceTemplatesQueryVariables
  >(GetResourceTemplatesDocument, options)
}
export function useGetResourceTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetResourceTemplatesQuery,
    IGetResourceTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetResourceTemplatesQuery,
    IGetResourceTemplatesQueryVariables
  >(GetResourceTemplatesDocument, options)
}
export type GetResourceTemplatesQueryHookResult = ReturnType<
  typeof useGetResourceTemplatesQuery
>
export type GetResourceTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetResourceTemplatesLazyQuery
>
export type GetResourceTemplatesQueryResult = Apollo.QueryResult<
  IGetResourceTemplatesQuery,
  IGetResourceTemplatesQueryVariables
>
export const UpdateResourcePropertyDocument = gql`
  mutation UpdateResourceProperty(
    $projectId: ObjectId!
    $id: ObjectId!
    $input: UpdateResourcePropertyInput!
  ) {
    updateResourceProperty(projectId: $projectId, id: $id, input: $input) {
      id
      name
      displayName
      position
      configuration {
        multiline
        format
        options {
          value
          label
          deleted
          parentValue
        }
        allowCustomOptions
        includeNoneOption
        maxFiles
        acceptedFileTypes
        maxFileSizeMb
        resourceLink {
          targetResourceType
          exclusive
        }
        importExport {
          entityType
          exportField
          importField
        }
      }
    }
  }
`
export type IUpdateResourcePropertyMutationFn = Apollo.MutationFunction<
  IUpdateResourcePropertyMutation,
  IUpdateResourcePropertyMutationVariables
>

/**
 * __useUpdateResourcePropertyMutation__
 *
 * To run a mutation, you first call `useUpdateResourcePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourcePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourcePropertyMutation, { data, loading, error }] = useUpdateResourcePropertyMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourcePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateResourcePropertyMutation,
    IUpdateResourcePropertyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateResourcePropertyMutation,
    IUpdateResourcePropertyMutationVariables
  >(UpdateResourcePropertyDocument, options)
}
export type UpdateResourcePropertyMutationHookResult = ReturnType<
  typeof useUpdateResourcePropertyMutation
>
export type UpdateResourcePropertyMutationResult =
  Apollo.MutationResult<IUpdateResourcePropertyMutation>
export type UpdateResourcePropertyMutationOptions = Apollo.BaseMutationOptions<
  IUpdateResourcePropertyMutation,
  IUpdateResourcePropertyMutationVariables
>
export const CreateResourcePropertyDocument = gql`
  mutation CreateResourceProperty(
    $projectId: ObjectId!
    $input: CreateResourcePropertyInput!
  ) {
    createResourceProperty(projectId: $projectId, input: $input) {
      id
      resourceTypeId
      isExternal
      name
      displayName
      propertyType
      position
      updatedAt
      configuration {
        multiline
        format
        options {
          value
          label
          deleted
          parentValue
        }
        allowCustomOptions
        includeNoneOption
        computationKind
        fromField
        toField
        unit
        maxFiles
        acceptedFileTypes
        maxFileSizeMb
        resourceLink {
          targetResourceType
          exclusive
        }
        importExport {
          entityType
          exportField
          importField
        }
      }
    }
  }
`
export type ICreateResourcePropertyMutationFn = Apollo.MutationFunction<
  ICreateResourcePropertyMutation,
  ICreateResourcePropertyMutationVariables
>

/**
 * __useCreateResourcePropertyMutation__
 *
 * To run a mutation, you first call `useCreateResourcePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourcePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourcePropertyMutation, { data, loading, error }] = useCreateResourcePropertyMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResourcePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateResourcePropertyMutation,
    ICreateResourcePropertyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateResourcePropertyMutation,
    ICreateResourcePropertyMutationVariables
  >(CreateResourcePropertyDocument, options)
}
export type CreateResourcePropertyMutationHookResult = ReturnType<
  typeof useCreateResourcePropertyMutation
>
export type CreateResourcePropertyMutationResult =
  Apollo.MutationResult<ICreateResourcePropertyMutation>
export type CreateResourcePropertyMutationOptions = Apollo.BaseMutationOptions<
  ICreateResourcePropertyMutation,
  ICreateResourcePropertyMutationVariables
>
export const DeleteResourcePropertyDocument = gql`
  mutation DeleteResourceProperty($projectId: ObjectId!, $id: ObjectId!) {
    deleteResourceProperty(projectId: $projectId, id: $id)
  }
`
export type IDeleteResourcePropertyMutationFn = Apollo.MutationFunction<
  IDeleteResourcePropertyMutation,
  IDeleteResourcePropertyMutationVariables
>

/**
 * __useDeleteResourcePropertyMutation__
 *
 * To run a mutation, you first call `useDeleteResourcePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourcePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourcePropertyMutation, { data, loading, error }] = useDeleteResourcePropertyMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourcePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteResourcePropertyMutation,
    IDeleteResourcePropertyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteResourcePropertyMutation,
    IDeleteResourcePropertyMutationVariables
  >(DeleteResourcePropertyDocument, options)
}
export type DeleteResourcePropertyMutationHookResult = ReturnType<
  typeof useDeleteResourcePropertyMutation
>
export type DeleteResourcePropertyMutationResult =
  Apollo.MutationResult<IDeleteResourcePropertyMutation>
export type DeleteResourcePropertyMutationOptions = Apollo.BaseMutationOptions<
  IDeleteResourcePropertyMutation,
  IDeleteResourcePropertyMutationVariables
>
export const CreateResourceTemplateDocument = gql`
  mutation CreateResourceTemplate(
    $projectId: ObjectId!
    $input: CreateResourceTemplateInput!
  ) {
    createResourceTemplate(projectId: $projectId, input: $input) {
      id
      resourceTypeId
      name
    }
  }
`
export type ICreateResourceTemplateMutationFn = Apollo.MutationFunction<
  ICreateResourceTemplateMutation,
  ICreateResourceTemplateMutationVariables
>

/**
 * __useCreateResourceTemplateMutation__
 *
 * To run a mutation, you first call `useCreateResourceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceTemplateMutation, { data, loading, error }] = useCreateResourceTemplateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResourceTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateResourceTemplateMutation,
    ICreateResourceTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateResourceTemplateMutation,
    ICreateResourceTemplateMutationVariables
  >(CreateResourceTemplateDocument, options)
}
export type CreateResourceTemplateMutationHookResult = ReturnType<
  typeof useCreateResourceTemplateMutation
>
export type CreateResourceTemplateMutationResult =
  Apollo.MutationResult<ICreateResourceTemplateMutation>
export type CreateResourceTemplateMutationOptions = Apollo.BaseMutationOptions<
  ICreateResourceTemplateMutation,
  ICreateResourceTemplateMutationVariables
>
export const UpdateResourceTemplateDocument = gql`
  mutation UpdateResourceTemplate(
    $projectId: ObjectId!
    $id: ObjectId!
    $input: UpdateResourceTemplateInput!
  ) {
    updateResourceTemplate(projectId: $projectId, id: $id, input: $input) {
      id
      properties {
        propertyId
        propertyName
        orderIndex
        isRequired
        isHidden
        defaultValue
      }
    }
  }
`
export type IUpdateResourceTemplateMutationFn = Apollo.MutationFunction<
  IUpdateResourceTemplateMutation,
  IUpdateResourceTemplateMutationVariables
>

/**
 * __useUpdateResourceTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateResourceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceTemplateMutation, { data, loading, error }] = useUpdateResourceTemplateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourceTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateResourceTemplateMutation,
    IUpdateResourceTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateResourceTemplateMutation,
    IUpdateResourceTemplateMutationVariables
  >(UpdateResourceTemplateDocument, options)
}
export type UpdateResourceTemplateMutationHookResult = ReturnType<
  typeof useUpdateResourceTemplateMutation
>
export type UpdateResourceTemplateMutationResult =
  Apollo.MutationResult<IUpdateResourceTemplateMutation>
export type UpdateResourceTemplateMutationOptions = Apollo.BaseMutationOptions<
  IUpdateResourceTemplateMutation,
  IUpdateResourceTemplateMutationVariables
>
export const DeleteResourceTemplateDocument = gql`
  mutation DeleteResourceTemplate($projectId: ObjectId!, $id: ObjectId!) {
    deleteResourceTemplate(projectId: $projectId, id: $id)
  }
`
export type IDeleteResourceTemplateMutationFn = Apollo.MutationFunction<
  IDeleteResourceTemplateMutation,
  IDeleteResourceTemplateMutationVariables
>

/**
 * __useDeleteResourceTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteResourceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceTemplateMutation, { data, loading, error }] = useDeleteResourceTemplateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteResourceTemplateMutation,
    IDeleteResourceTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteResourceTemplateMutation,
    IDeleteResourceTemplateMutationVariables
  >(DeleteResourceTemplateDocument, options)
}
export type DeleteResourceTemplateMutationHookResult = ReturnType<
  typeof useDeleteResourceTemplateMutation
>
export type DeleteResourceTemplateMutationResult =
  Apollo.MutationResult<IDeleteResourceTemplateMutation>
export type DeleteResourceTemplateMutationOptions = Apollo.BaseMutationOptions<
  IDeleteResourceTemplateMutation,
  IDeleteResourceTemplateMutationVariables
>
export const DeleteManyResourceTemplatesDocument = gql`
  mutation DeleteManyResourceTemplates(
    $projectId: ObjectId!
    $ids: [ObjectId!]!
  ) {
    deleteManyResourceTemplates(projectId: $projectId, ids: $ids)
  }
`
export type IDeleteManyResourceTemplatesMutationFn = Apollo.MutationFunction<
  IDeleteManyResourceTemplatesMutation,
  IDeleteManyResourceTemplatesMutationVariables
>

/**
 * __useDeleteManyResourceTemplatesMutation__
 *
 * To run a mutation, you first call `useDeleteManyResourceTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyResourceTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyResourceTemplatesMutation, { data, loading, error }] = useDeleteManyResourceTemplatesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteManyResourceTemplatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteManyResourceTemplatesMutation,
    IDeleteManyResourceTemplatesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteManyResourceTemplatesMutation,
    IDeleteManyResourceTemplatesMutationVariables
  >(DeleteManyResourceTemplatesDocument, options)
}
export type DeleteManyResourceTemplatesMutationHookResult = ReturnType<
  typeof useDeleteManyResourceTemplatesMutation
>
export type DeleteManyResourceTemplatesMutationResult =
  Apollo.MutationResult<IDeleteManyResourceTemplatesMutation>
export type DeleteManyResourceTemplatesMutationOptions =
  Apollo.BaseMutationOptions<
    IDeleteManyResourceTemplatesMutation,
    IDeleteManyResourceTemplatesMutationVariables
  >
export const UpdateResourceTemplatePropertySettingsDocument = gql`
  mutation UpdateResourceTemplatePropertySettings(
    $projectId: ObjectId!
    $templateId: ObjectId!
    $propertyId: ObjectId!
    $input: TemplatePropertySettingsInput!
  ) {
    updateTemplatePropertySettings(
      projectId: $projectId
      templateId: $templateId
      propertyId: $propertyId
      input: $input
    ) {
      id
      properties {
        propertyId
        propertyName
        orderIndex
        isRequired
        isHidden
        defaultValue
      }
    }
  }
`
export type IUpdateResourceTemplatePropertySettingsMutationFn =
  Apollo.MutationFunction<
    IUpdateResourceTemplatePropertySettingsMutation,
    IUpdateResourceTemplatePropertySettingsMutationVariables
  >

/**
 * __useUpdateResourceTemplatePropertySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateResourceTemplatePropertySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceTemplatePropertySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceTemplatePropertySettingsMutation, { data, loading, error }] = useUpdateResourceTemplatePropertySettingsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      templateId: // value for 'templateId'
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourceTemplatePropertySettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateResourceTemplatePropertySettingsMutation,
    IUpdateResourceTemplatePropertySettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateResourceTemplatePropertySettingsMutation,
    IUpdateResourceTemplatePropertySettingsMutationVariables
  >(UpdateResourceTemplatePropertySettingsDocument, options)
}
export type UpdateResourceTemplatePropertySettingsMutationHookResult =
  ReturnType<typeof useUpdateResourceTemplatePropertySettingsMutation>
export type UpdateResourceTemplatePropertySettingsMutationResult =
  Apollo.MutationResult<IUpdateResourceTemplatePropertySettingsMutation>
export type UpdateResourceTemplatePropertySettingsMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateResourceTemplatePropertySettingsMutation,
    IUpdateResourceTemplatePropertySettingsMutationVariables
  >
export const ParseResourceImportFileDocument = gql`
  query ParseResourceImportFile(
    $projectId: ObjectId!
    $storagePath: String!
    $resourceTypeId: String!
  ) {
    parseResourceImportFile(
      projectId: $projectId
      storagePath: $storagePath
      resourceTypeId: $resourceTypeId
    ) {
      headers
      rowCount
      suggestedMappings {
        columnIndex
        columnHeader
        propertyId
        propertyName
        field
      }
    }
  }
`

/**
 * __useParseResourceImportFileQuery__
 *
 * To run a query within a React component, call `useParseResourceImportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useParseResourceImportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParseResourceImportFileQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      storagePath: // value for 'storagePath'
 *      resourceTypeId: // value for 'resourceTypeId'
 *   },
 * });
 */
export function useParseResourceImportFileQuery(
  baseOptions: Apollo.QueryHookOptions<
    IParseResourceImportFileQuery,
    IParseResourceImportFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IParseResourceImportFileQuery,
    IParseResourceImportFileQueryVariables
  >(ParseResourceImportFileDocument, options)
}
export function useParseResourceImportFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IParseResourceImportFileQuery,
    IParseResourceImportFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IParseResourceImportFileQuery,
    IParseResourceImportFileQueryVariables
  >(ParseResourceImportFileDocument, options)
}
export type ParseResourceImportFileQueryHookResult = ReturnType<
  typeof useParseResourceImportFileQuery
>
export type ParseResourceImportFileLazyQueryHookResult = ReturnType<
  typeof useParseResourceImportFileLazyQuery
>
export type ParseResourceImportFileQueryResult = Apollo.QueryResult<
  IParseResourceImportFileQuery,
  IParseResourceImportFileQueryVariables
>
export const ExecuteResourceImportDocument = gql`
  mutation ExecuteResourceImport(
    $projectId: ObjectId!
    $storagePath: String!
    $resourceTypeId: String!
    $templateId: String!
    $mappings: [ColumnMappingInput!]!
  ) {
    executeResourceImport(
      projectId: $projectId
      storagePath: $storagePath
      resourceTypeId: $resourceTypeId
      templateId: $templateId
      mappings: $mappings
    ) {
      created
      updated
      failed
      errors {
        row
        propertyName
        value
        message
      }
    }
  }
`
export type IExecuteResourceImportMutationFn = Apollo.MutationFunction<
  IExecuteResourceImportMutation,
  IExecuteResourceImportMutationVariables
>

/**
 * __useExecuteResourceImportMutation__
 *
 * To run a mutation, you first call `useExecuteResourceImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteResourceImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeResourceImportMutation, { data, loading, error }] = useExecuteResourceImportMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      storagePath: // value for 'storagePath'
 *      resourceTypeId: // value for 'resourceTypeId'
 *      templateId: // value for 'templateId'
 *      mappings: // value for 'mappings'
 *   },
 * });
 */
export function useExecuteResourceImportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IExecuteResourceImportMutation,
    IExecuteResourceImportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IExecuteResourceImportMutation,
    IExecuteResourceImportMutationVariables
  >(ExecuteResourceImportDocument, options)
}
export type ExecuteResourceImportMutationHookResult = ReturnType<
  typeof useExecuteResourceImportMutation
>
export type ExecuteResourceImportMutationResult =
  Apollo.MutationResult<IExecuteResourceImportMutation>
export type ExecuteResourceImportMutationOptions = Apollo.BaseMutationOptions<
  IExecuteResourceImportMutation,
  IExecuteResourceImportMutationVariables
>
export const ExportResourceRecordsDocument = gql`
  mutation ExportResourceRecords(
    $projectId: ObjectId!
    $input: ResourceExportRecordsInput!
  ) {
    exportResourceRecords(projectId: $projectId, input: $input) {
      data
      filename
      mimeType
    }
  }
`
export type IExportResourceRecordsMutationFn = Apollo.MutationFunction<
  IExportResourceRecordsMutation,
  IExportResourceRecordsMutationVariables
>

/**
 * __useExportResourceRecordsMutation__
 *
 * To run a mutation, you first call `useExportResourceRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportResourceRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportResourceRecordsMutation, { data, loading, error }] = useExportResourceRecordsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportResourceRecordsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IExportResourceRecordsMutation,
    IExportResourceRecordsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IExportResourceRecordsMutation,
    IExportResourceRecordsMutationVariables
  >(ExportResourceRecordsDocument, options)
}
export type ExportResourceRecordsMutationHookResult = ReturnType<
  typeof useExportResourceRecordsMutation
>
export type ExportResourceRecordsMutationResult =
  Apollo.MutationResult<IExportResourceRecordsMutation>
export type ExportResourceRecordsMutationOptions = Apollo.BaseMutationOptions<
  IExportResourceRecordsMutation,
  IExportResourceRecordsMutationVariables
>
export const BulkEditResourcePropertiesDocument = gql`
  mutation BulkEditResourceProperties(
    $projectId: ObjectId!
    $input: BulkEditResourcePropertiesInput!
  ) {
    bulkEditResourceProperties(projectId: $projectId, input: $input)
  }
`
export type IBulkEditResourcePropertiesMutationFn = Apollo.MutationFunction<
  IBulkEditResourcePropertiesMutation,
  IBulkEditResourcePropertiesMutationVariables
>

/**
 * __useBulkEditResourcePropertiesMutation__
 *
 * To run a mutation, you first call `useBulkEditResourcePropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEditResourcePropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEditResourcePropertiesMutation, { data, loading, error }] = useBulkEditResourcePropertiesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkEditResourcePropertiesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkEditResourcePropertiesMutation,
    IBulkEditResourcePropertiesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkEditResourcePropertiesMutation,
    IBulkEditResourcePropertiesMutationVariables
  >(BulkEditResourcePropertiesDocument, options)
}
export type BulkEditResourcePropertiesMutationHookResult = ReturnType<
  typeof useBulkEditResourcePropertiesMutation
>
export type BulkEditResourcePropertiesMutationResult =
  Apollo.MutationResult<IBulkEditResourcePropertiesMutation>
export type BulkEditResourcePropertiesMutationOptions =
  Apollo.BaseMutationOptions<
    IBulkEditResourcePropertiesMutation,
    IBulkEditResourcePropertiesMutationVariables
  >
export const GetResourcePropertyUsageCountDocument = gql`
  query GetResourcePropertyUsageCount($projectId: ObjectId!, $id: ObjectId!) {
    resourcePropertyUsageCount(projectId: $projectId, id: $id)
  }
`

/**
 * __useGetResourcePropertyUsageCountQuery__
 *
 * To run a query within a React component, call `useGetResourcePropertyUsageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcePropertyUsageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcePropertyUsageCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResourcePropertyUsageCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetResourcePropertyUsageCountQuery,
    IGetResourcePropertyUsageCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetResourcePropertyUsageCountQuery,
    IGetResourcePropertyUsageCountQueryVariables
  >(GetResourcePropertyUsageCountDocument, options)
}
export function useGetResourcePropertyUsageCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetResourcePropertyUsageCountQuery,
    IGetResourcePropertyUsageCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetResourcePropertyUsageCountQuery,
    IGetResourcePropertyUsageCountQueryVariables
  >(GetResourcePropertyUsageCountDocument, options)
}
export type GetResourcePropertyUsageCountQueryHookResult = ReturnType<
  typeof useGetResourcePropertyUsageCountQuery
>
export type GetResourcePropertyUsageCountLazyQueryHookResult = ReturnType<
  typeof useGetResourcePropertyUsageCountLazyQuery
>
export type GetResourcePropertyUsageCountQueryResult = Apollo.QueryResult<
  IGetResourcePropertyUsageCountQuery,
  IGetResourcePropertyUsageCountQueryVariables
>
export const ArchiveResourcePropertyDocument = gql`
  mutation ArchiveResourceProperty($projectId: ObjectId!, $id: ObjectId!) {
    archiveResourceProperty(projectId: $projectId, id: $id)
  }
`
export type IArchiveResourcePropertyMutationFn = Apollo.MutationFunction<
  IArchiveResourcePropertyMutation,
  IArchiveResourcePropertyMutationVariables
>

/**
 * __useArchiveResourcePropertyMutation__
 *
 * To run a mutation, you first call `useArchiveResourcePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveResourcePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveResourcePropertyMutation, { data, loading, error }] = useArchiveResourcePropertyMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveResourcePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IArchiveResourcePropertyMutation,
    IArchiveResourcePropertyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IArchiveResourcePropertyMutation,
    IArchiveResourcePropertyMutationVariables
  >(ArchiveResourcePropertyDocument, options)
}
export type ArchiveResourcePropertyMutationHookResult = ReturnType<
  typeof useArchiveResourcePropertyMutation
>
export type ArchiveResourcePropertyMutationResult =
  Apollo.MutationResult<IArchiveResourcePropertyMutation>
export type ArchiveResourcePropertyMutationOptions = Apollo.BaseMutationOptions<
  IArchiveResourcePropertyMutation,
  IArchiveResourcePropertyMutationVariables
>
export const UnarchiveResourcePropertyDocument = gql`
  mutation UnarchiveResourceProperty($projectId: ObjectId!, $id: ObjectId!) {
    unarchiveResourceProperty(projectId: $projectId, id: $id)
  }
`
export type IUnarchiveResourcePropertyMutationFn = Apollo.MutationFunction<
  IUnarchiveResourcePropertyMutation,
  IUnarchiveResourcePropertyMutationVariables
>

/**
 * __useUnarchiveResourcePropertyMutation__
 *
 * To run a mutation, you first call `useUnarchiveResourcePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveResourcePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveResourcePropertyMutation, { data, loading, error }] = useUnarchiveResourcePropertyMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveResourcePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUnarchiveResourcePropertyMutation,
    IUnarchiveResourcePropertyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUnarchiveResourcePropertyMutation,
    IUnarchiveResourcePropertyMutationVariables
  >(UnarchiveResourcePropertyDocument, options)
}
export type UnarchiveResourcePropertyMutationHookResult = ReturnType<
  typeof useUnarchiveResourcePropertyMutation
>
export type UnarchiveResourcePropertyMutationResult =
  Apollo.MutationResult<IUnarchiveResourcePropertyMutation>
export type UnarchiveResourcePropertyMutationOptions =
  Apollo.BaseMutationOptions<
    IUnarchiveResourcePropertyMutation,
    IUnarchiveResourcePropertyMutationVariables
  >
export const HierarchyPropertyOptionUsageDocument = gql`
  query HierarchyPropertyOptionUsage(
    $projectId: ObjectId!
    $propertyId: ObjectId!
  ) {
    hierarchyPropertyOptionUsage(projectId: $projectId, propertyId: $propertyId)
  }
`

/**
 * __useHierarchyPropertyOptionUsageQuery__
 *
 * To run a query within a React component, call `useHierarchyPropertyOptionUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyPropertyOptionUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyPropertyOptionUsageQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useHierarchyPropertyOptionUsageQuery(
  baseOptions: Apollo.QueryHookOptions<
    IHierarchyPropertyOptionUsageQuery,
    IHierarchyPropertyOptionUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IHierarchyPropertyOptionUsageQuery,
    IHierarchyPropertyOptionUsageQueryVariables
  >(HierarchyPropertyOptionUsageDocument, options)
}
export function useHierarchyPropertyOptionUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IHierarchyPropertyOptionUsageQuery,
    IHierarchyPropertyOptionUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IHierarchyPropertyOptionUsageQuery,
    IHierarchyPropertyOptionUsageQueryVariables
  >(HierarchyPropertyOptionUsageDocument, options)
}
export type HierarchyPropertyOptionUsageQueryHookResult = ReturnType<
  typeof useHierarchyPropertyOptionUsageQuery
>
export type HierarchyPropertyOptionUsageLazyQueryHookResult = ReturnType<
  typeof useHierarchyPropertyOptionUsageLazyQuery
>
export type HierarchyPropertyOptionUsageQueryResult = Apollo.QueryResult<
  IHierarchyPropertyOptionUsageQuery,
  IHierarchyPropertyOptionUsageQueryVariables
>
